import { graphql } from "../generated/gql";

export const GetAudio = graphql(
  `
    query GetAudio($callId: ID!, $callType: AudioType!) {
      getAudio(callId: $callId, callType: $callType) {
        ...CallAudio
        ... on GenericException {
          ...BaseException
        }
        ...InsufficientPermissionException
        ... on ResourceNotFoundException {
          ...BaseException
        }
      }
    }
  `
);
